import React from 'react';
import _ from 'lodash';

export class SelectedPreview extends React.Component {

    createArr = () => {
        const newArr = [];
        const {items,selected} = this.props;
        _.forEach(items, (value)  => {
            if(selected[value.curatedCollectionId]){
                newArr.push(value);
            }
        });
        return newArr;
    };

    createTableBody = () => {
        const arr = this.createArr();
        let itemArr = [];
        arr.map((curatedCollection, key) => {
            itemArr.push(
                <div className="table-items" key={key}>
                    <div className="thumbnail">
                        {curatedCollection.parentCollection.thumbnailUrl ? (
                            <img src={curatedCollection.parentCollection.thumbnailUrl} width='60px' height='60px' />
                        ) : (
                            <div className="placeholder">No Image</div>
                        )}
                    </div>
                    <div className="table-content">
                        <h3 className="title-text">{curatedCollection.parentCollection.title}</h3>
                        <p>{curatedCollection.parentCollection.description}</p>
                    </div>
                </div>);
        });
        return itemArr;
    };

    render() {
        const tableBody = this.createTableBody();
        return(<div className="preview-table">
            <div className="table-wrapper">
                <div className="table-header">
                    <div className="file-selected">
                        Files Selected
                    </div>
                    <div className="deselect-all">
                        <span onClick={this.props.deselect}>Deselect All</span>
                    </div>
                </div>
                <div className="table-body">
                    {tableBody}
                </div>
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/CuratedSearch/SelectedPreview.js